import { Injectable } from '@angular/core';
import { CountryLanguages, LanguageDetailsResult } from '../../models/utils';

@Injectable({ providedIn: 'root' })
export class LanguageFinderService {
  findLanguageDetails(
    countryCode: string,
    languageCode: string,
    key: 'isoCode' | 'urlcc',
    list: CountryLanguages[]
  ): LanguageDetailsResult | null {
    const country = list?.find((c) => c?.[key] === countryCode);
    const language = country?.languageDtls?.find(
      (l) => l?.languageCode === languageCode
    );
    return language
      ? { countryMatch: country, languageDetails: language }
      : null;
  }

  isValidPath(country?: string, lang?: string): boolean {
    return !!(country && lang && country.length <= 4 && lang.length === 2);
  }
}
